module.exports = __webpack_public_path__ + "static/media/gallery-4.441dc9e2.jpg";